<template>
  <div class="page flex-col">
    <!-- 头部已抽取为全局组件 SiteHeader -->
    <!-- 保留中部内容块 block_2 -->
    <div class="block_2 flex-col">
      <!-- 移除页面内导航栏，统一由 SiteHeader 控制 -->
      <!-- 原导航所在位置删除，仅保留后续内容 -->
      <div class="carousel-container flex-col">
        <LanhuCarousel :images="carouselImages" />
      </div>
      <span class="text_9">成果简介</span>
      <img
        class="image_4"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng33e6061372a0b8e0aa0dad9bdce6bd1c8fbe39d3927584658efa75311aee57ba.png"
      />
      <span class="text_10">
        党的二十大报告将"推进教育强国建设"与"加快发展数字经济"列为中国式现代化的战略重点。与此同时，国家加快建设"制造强国"、"贸易强国"的战略号角全面吹响。跨境电商作为数字贸易核心业态与外贸转型升级的战略引擎，正加速向数据驱动、AI赋能的智能化生态演进，亟需培育大批具备数字技术应用、数据驱动决策与全球化数字运营能力的高技能人才。面对这一时代命题，聚焦国家重点战略，紧密对接安徽省"1188"现代化产业体系及"技能安徽"建设，依托安徽工商职业学院跨境电子商务专业（2016年全省率先开设，2020年正式招生并获批省级高水平专业群），联合合肥荣事达集团、安徽省进出口商会等行业龙头，历经10余年实践探索，构建"标准引领、生态共生、数智驱动、德技互嵌"跨境电商新质技能人才集群培养体系：一是首创构建"标准引领、生态共生"的"三融三共"产教融合新范式。依托产教融合共同体，将产业人才需求标准、国家专业教学标准与头部企业岗位标准动态融通，在融标准、融机制、融资源的基础上，推动校企共建教学资源、共享育人成果、共育技能英才，实现教育链与产业链的有机咬合。二是系统打造"数智驱动、场景赋能"的"三链三化"模块育人新体系。以关键教学要素改革为抓手，推进"课程链+赛证链+育训链"深度融通；通过"内容数智化、载体场景化、能力分级化"的科教融汇路径，系统破解培养协同性弱与实战能力不足的难题。三是着力构筑"德技互嵌、价值闭环"的"三德三匠"协同育人新机制。以"传承古丝路文明互鉴之德、恪守新丝路诚信守规之德、担当数字贸易强国之德"为思政主线，三德铸魂；通过师带徒传承匠艺、国赛实战磨砺匠志、荣事达创客空间丝路项目涵养匠魂，三匠砺能，培育兼具精湛数字技艺与新丝路开拓精神的大国工匠。通过培养体系实施，形成了可复制、可推广的跨境电商高技能人才集群培养"安徽工商方案"，成为全国跨境电商高技能人才培养的主阵地、国家专业教学标准的重要参与制定者、区域跨境电商产业创新发展的核心助推者，在全国高职同类专业中发挥了显著的示范引领作用。
      </span>
      <span class="text_11" @click="navigateToIntro" style="cursor: pointer; color: #215195; font-weight: 600;">点击查看更多&gt;&gt;</span>
      <span class="text_12">成果内容</span>
      <img
        class="image_5"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng33e6061372a0b8e0aa0dad9bdce6bd1c8fbe39d3927584658efa75311aee57ba.png"
      />
      <div class="grid_1 flex-row">
        <div
          class="list-items_1 flex-col"
          :style="{ background: item.lanhuBg0 }"
          v-for="(item, index) in loopData0"
          :key="index"
          @click="navigateToDetail(loopTypes[index])"
          style="cursor: pointer;"
        >
          <div class="text-wrapper_2 flex-col" :style="{ background: item.lanhuBg1 }">
            <span class="text_13" v-html="item.lanhutext0"></span>
          </div>
        </div>
      </div>
      <span class="text_14">成果价值</span>
      <img
        class="image_6"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng33e6061372a0b8e0aa0dad9bdce6bd1c8fbe39d3927584658efa75311aee57ba.png"
      />
      <div class="section_3 flex-row justify-between">
        <div class="group_1 flex-col" @click="navigateToValue('德技双馨')" style="cursor: pointer;">
          <div class="text-wrapper_3 flex-col">
            <img class="value-img" src="./assets/img/SketchPnge2f67535b2032e19741e9efa4590eb62ebaff2e27c14828b99ee8abdbf5bc6f7.png" alt="德技双馨 提质赋能 背景" />
            <span class="paragraph_1">
              德技双馨
              <br />
              提质赋能
            </span>
          </div>
        </div>
        <div class="group_2 flex-col" @click="navigateToValue('教学示范')" style="cursor: pointer;">
          <div class="text-wrapper_4 flex-col">
            <img class="value-img" src="./assets/img/SketchPng550f78b74638d0d7a69ce96e74e460ff1eccf14caf1fe8ff81b61543cf6941bf.png" alt="教学示范 辐射引领 背景" />
            <span class="paragraph_2">
              教学示范
              <br />
              辐射引领
            </span>
          </div>
        </div>
        <div class="group_3 flex-col" @click="navigateToValue('服务社会')" style="cursor: pointer;">
          <div class="text-wrapper_5 flex-col">
            <img class="value-img" src="./assets/img/SketchPng68ae7aaf186b470ffbac95e3f88b48853e360d9059ee98f2c749e3ed6c3dfe02.png" alt="服务社会 赋能发展 背景" />
            <span class="paragraph_3">
              服务社会
              <br />
              赋能发展
            </span>
          </div>
        </div>
        <div class="group_4 flex-col" @click="navigateToValue('引领示范')" style="cursor: pointer;">
          <div class="text-wrapper_6 flex-col">
            <img class="value-img" src="./assets/img/SketchPngd4ae08396488838841ae9db601a3025336d5cde38753b55a5e38d22c31386b51.png" alt="引领示范 誉满业界 背景" />
            <span class="paragraph_4">
              引领示范
              <br />
              誉满业界
            </span>
          </div>
        </div>
      </div>
      <!-- 移除页面内自定义底部模块，统一使用全局 SiteFooter -->
      <!-- 原 block_3 与段落/图片内容已并入全局页脚的 sf-motto 与 sf-row 中，实现首页与详情页一致的底部样式 -->
    </div>
    <!-- 删除页面内底部，使用全局 SiteFooter -->
  </div>
</template>
<script>
 import LanhuCarousel from '../../components/LanhuCarousel.vue'
 export default {
  components: { LanhuCarousel },
   data() {
     return {
       // 轮播内部状态交由组件维护
      carouselImages: [
        {
          src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/1-%E5%AE%89%E5%BE%BD%E5%B7%A5%E5%95%86%E8%81%8C%E4%B8%9A%E5%AD%A6%E9%99%A2%E4%B8%8E%E5%90%88%E8%82%A5%E8%8D%A3%E4%BA%8B%E8%BE%BE%E7%94%B5%E5%AD%90%E7%94%B5%E5%99%A8%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E5%AE%9E%E4%B9%A0%E5%AE%9E%E8%AE%AD%E5%9F%BA%E5%9C%B0%E6%8F%AD%E7%89%8C%E4%BB%AA%E5%BC%8F.jpg',
          alt: '安徽工商职业学院与合肥荣事达电子电器集团有限公司实习实训基地揭牌仪式'
        },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/2-%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E8%B7%A8%E5%A2%83%E7%94%B5%E5%AD%90%E5%95%86%E5%8A%A1%E4%B8%93%E4%B8%9A2025%E7%BA%A7%E6%96%B0%E7%94%9F%E8%B5%B4%E8%8D%A3%E4%BA%8B%E8%BE%BE%E9%9B%86%E5%9B%A2%E5%BC%80%E5%B1%95%E4%B8%93%E4%B8%9A%E8%AE%A4%E7%9F%A5%E5%AE%9E%E4%B9%A0.jpg',
         alt: '经济贸易学院跨境电子商务专业2025级新生赴荣事达集团开展专业认知实习'
       },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/3-%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E8%B7%A8%E5%A2%83%E7%94%B5%E5%95%86%E4%B8%93%E4%B8%9A%E6%95%99%E5%B8%88%E5%9C%A82025%E5%B9%B4%E5%AE%89%E5%BE%BD%E7%9C%81%E8%81%8C%E4%B8%9A%E9%99%A2%E6%A0%A1%E6%95%99%E5%B8%88%E6%95%99%E5%AD%A6%E8%83%BD%E5%8A%9B%E5%A4%A7%E8%B5%9B%E4%B8%AD%E6%96%A9%E8%8E%B7%E4%B8%80%E7%AD%89%E5%A5%96.jpg',
         alt: '经济贸易学院跨境电商专业教师在2025年安徽省职业院校教师教学能力大赛中斩获一等奖'
       },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/4-%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E8%B7%A8%E5%A2%83%E7%94%B5%E5%95%86%E4%B8%93%E4%B8%9A%E5%AD%A6%E7%94%9F%E5%9C%A82025%E5%B9%B4%E4%B8%96%E7%95%8C%E8%81%8C%E4%B8%9A%E9%99%A2%E6%A0%A1%E6%8A%80%E8%83%BD%E5%A4%A7%E8%B5%9B%E5%95%86%E8%B4%B8%E8%B5%9B%E9%81%93%E4%BA%89%E5%A4%BA%E8%B5%9B%E4%B8%AD%E8%8D%A3%E8%8E%B7%E4%B8%80%E9%93%B6%E4%B8%80%E9%93%9C.jpg',
         alt: '经济贸易学院跨境电商专业学生在2025年世界职业院校技能大赛商贸赛道争夺赛中荣获一银一铜'
       },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/5-%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E5%8F%AC%E5%BC%802025%E7%BA%A7%E8%B7%A8%E5%A2%83%E7%94%B5%E5%AD%90%E5%95%86%E5%95%86%E4%B8%93%E4%B8%9A%E4%BA%BA%E6%89%8D%E5%9F%B9%E5%85%BB%E6%96%B9%E6%A1%88%E8%AE%BA%E8%AF%81%E4%BC%9A.jpg',
         alt: '经济贸易学院召开2025级跨境电子商商专业人才培养方案论证会'
       },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/6-%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E8%B7%A8%E5%A2%83%E7%94%B5%E5%95%86%E4%B8%93%E4%B8%9A%E5%8F%A4%E6%B3%89%E6%83%A0%E5%86%9C%E5%BF%97%E6%84%BF%E6%9C%8D%E5%8A%A1%E9%98%9F%E8%B5%B4%E5%AE%A3%E5%9F%8E%E5%8F%A4%E6%B3%89%E9%95%87%E5%BC%80%E5%B1%95%E4%B9%A1%E6%9D%91%E6%8C%AF%E5%85%B4%E5%AE%9E%E8%B7%B5%E6%B4%BB%E5%8A%A8.jpeg',
         alt: '经济贸易学院跨境电商专业古泉惠农志愿服务队赴宣城古泉镇开展乡村振兴实践活动'
       },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/7-%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E8%B7%A8%E5%A2%83%E7%94%B5%E5%95%86%E4%B8%93%E4%B8%9A%E5%AD%A6%E7%94%9F%E5%9C%A82025%E5%B9%B4%E5%AE%89%E5%BE%BD%E7%9C%81%E5%A4%A7%E5%AD%A6%E7%94%9F%E5%9B%BD%E9%99%85%E8%B4%B8%E6%98%93%E7%BB%BC%E5%90%88%E6%8A%80%E8%83%BD%E5%A4%A7%E8%B5%9B%E4%B8%AD%E6%96%A9%E8%8E%B7%E4%B8%80%E7%AD%89%E5%A5%96.jpg',
         alt: '经济贸易学院跨境电商专业学生在2025年安徽省大学生国际贸易综合技能大赛中斩获一等奖'
       },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/8-%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E4%B8%BE%E5%8A%9E2025%E5%B9%B41%2BX%E8%B7%A8%E5%A2%83%E7%94%B5%E5%95%86B2B%E6%95%B0%E6%8D%AE%E8%BF%90%E8%90%A5%E8%81%8C%E4%B8%9A%E6%8A%80%E8%83%BD%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6%EF%BC%88%E4%B8%AD%E7%BA%A7%EF%BC%89%E8%80%83%E8%AF%95.jpg',
         alt: '经济贸易学院举办2025年1+X跨境电商B2B数据运营职业技能等级证书（中级）考试'
       },
       {
         src: 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/lunbo/9%E7%BB%8F%E6%B5%8E%E8%B4%B8%E6%98%93%E5%AD%A6%E9%99%A2%E8%B7%A8%E5%A2%83%E7%94%B5%E5%95%86%E4%B8%93%E4%B8%9A%E6%95%99%E5%B8%88%E5%9C%A82024%E5%B9%B4%E5%AE%89%E5%BE%BD%E7%9C%81%E8%81%8C%E4%B8%9A%E9%99%A2%E6%A0%A1%E6%95%99%E5%B8%88%E6%95%99%E5%AD%A6%E8%83%BD%E5%8A%9B%E5%A4%A7%E8%B5%9B%E4%B8%AD%E6%96%A9%E8%8E%B73%E4%B8%AA%E4%B8%80%E7%AD%89%E5%A5%96.jpg',
         alt: '经济贸易学院跨境电商专业教师在2024年安徽省职业院校教师教学能力大赛中斩获3个一等奖'
       }
      ],
      loopData0: [
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/a2ca8fe9289a4e54b548ba28a3493ddd_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPngca5d892d9c1b66a9bdabda34e8f8aa55e76893b376924c6b89e9ba0bddf0dbf4) 100% no-repeat',
          lanhutext0: '课程资源'
        },
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/f8da9663b7554f8391be0e0230683d79_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPngfb99a094a8187f7e4b39d054acb406b88d03efa94a6acd24135760245c234799) -1px 0px no-repeat',
          lanhutext0: '竞赛引领'
        },
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/be8b48fae97446ddbb9e4953e0b58a64_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPng9cb452cad5246c30c336dff13264c5cf2af30c7f169ed320b1a3ed211e4bd972) 0px 0px no-repeat',
          lanhutext0: '数智融合'
        },
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/5df1b531f53d4388b4652dac1c2ec854_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPngca5d892d9c1b66a9bdabda34e8f8aa55e76893b376924c6b89e9ba0bddf0dbf4) 100% no-repeat',
          lanhutext0: '证书赋能'
        },
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/ebbcdeac1a3f4c8d803db0944d0a622d_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPngfb99a094a8187f7e4b39d054acb406b88d03efa94a6acd24135760245c234799) -1px 0px no-repeat',
          lanhutext0: '双师团队'
        },
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/db95c11b2fd1473c88f6e283eaf509de_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPngca5d892d9c1b66a9bdabda34e8f8aa55e76893b376924c6b89e9ba0bddf0dbf4) 100% no-repeat',
          lanhutext0: '文化浸润'
        },
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/75cd672666c341e38b3b6ae40c3af8db_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPng9cb452cad5246c30c336dff13264c5cf2af30c7f169ed320b1a3ed211e4bd972) 0px 0px no-repeat',
          lanhutext0: '资源辐射'
        },
        {
          lanhuBg0:
            'url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/4a9ed96e62a542ac92da7f7ac883b735_mergeImage.png)',
          lanhuBg1:
            'url(https://lanhu-oss-proxy.lanhuapp.com/SketchPngca5d892d9c1b66a9bdabda34e8f8aa55e76893b376924c6b89e9ba0bddf0dbf4) 100% no-repeat',
          lanhutext0: '实训基地'
        }
      ],
      constants: {},
      // 为"成果内容"九宫格项提供与导航一致的跳转类型映射
      loopTypes: ['课程资源','竞赛引领','数智融合','证书赋能','双师团队','文化浸润','资源辐射','实训基地']
    };
  },
  methods: {
    // 首页"点击查看更多"跳转至成果简介详情页
    navigateToIntro() {
      this.$router.push('/lanhu/chengguojianjie');
    },
    // 首页“成果内容”九宫格点击跳转到对应的详情类型
    navigateToDetail(type) {
      this.$router.push({ path: '/lanhu/wenzhangxiangqing', query: { type } });
    },
    // 首页“成果价值”四卡片点击跳转到对应的价值类型
    navigateToValue(type) {
      this.$router.push({ path: '/lanhu/chengguojiazhi', query: { type } });
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 修复轮播与导航的层级、间距，避免遮挡（导航已移至 SiteHeader，本页仅保留轮播容器） */
.carousel-container { position: relative; z-index: 1; margin-top: 20px; }

/* 首页“成果简介”正文按段落展示：取消设计稿固定高度，避免溢出遮挡“查看更多” */
.text_10 { display: block; height: auto !important; white-space: normal !important; word-break: break-word; }
.text_11 { display: block; }
/* 正文高度随内容变化后，缩小与下一区块的间距 */
.text_12 { margin-top: 60px !important; }

/* 成果价值四卡片：统一一行排列与间距，避免多余 margin-left 导致断行/不对齐 */
.section_3 { justify-content: flex-start !important; align-items: flex-start !important; flex-wrap: nowrap; column-gap: 26px; }
.section_3 .group_2, .section_3 .group_3, .section_3 .group_4 { margin-left: 0 !important; }
/* 保障四卡片顶端对齐，移除可能存在的子项外边距影响 */
.section_3 > .flex-col { margin-top: 0 !important; margin-bottom: 0 !important; }

/* 移除页面内下拉菜单相关样式（已迁移至 SiteHeader） */
/* 取消第一张的背景偏移，统一用 <img> 填充 */
.section_3 .group_1 { background: transparent !important; border: 0 !important; overflow: hidden !important; }
/* 用 <img> 统一四张卡片的可视高度与裁剪方式 */
.section_3 .text-wrapper_3,
.section_3 .text-wrapper_4,
.section_3 .text-wrapper_5,
.section_3 .text-wrapper_6 { position: relative; background: none !important; }
.section_3 .value-img { position: absolute; left: 0; top: 0; width: 100% !important; height: 100% !important; object-fit: cover; object-position: center; display: block; }
/* 成果价值四卡片统一尺寸与背景填充，确保高度一致 */
.section_3 .text-wrapper_3,
.section_3 .text-wrapper_4,
.section_3 .text-wrapper_5,
.section_3 .text-wrapper_6 { height: 100% !important; width: 100% !important; }
/* 统一四个外层容器尺寸，移除内边距与边框，防止视觉高度差 */
.section_3 .group_1, .section_3 .group_2, .section_3 .group_3, .section_3 .group_4 { height: 200px !important; width: 287px !important; padding: 0 !important; border: 0 !important; overflow: hidden !important; }
/* 文字层级置顶，确保压在图片之上 */
.section_3 .paragraph_1,
.section_3 .paragraph_2,
.section_3 .paragraph_3,
.section_3 .paragraph_4 { position: relative; z-index: 2; }
.section_3 .group_3 { background: transparent !important; }
.section_3 .text-wrapper_3 .value-img { object-position: center; object-fit: cover; transform: scaleY(1.2); }
</style>